import { Box } from "@mui/material";
import { Snake } from "features/Snake";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "ui";

export default function NetworkError() {
  const { t } = useTranslation("Shared");
  // TODO Add message translation
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
        textAlign: "center",
        py: { md: 5 },
        gap: 4,
      }}
    >
      <Snake>
        <div className="mx-5 mt-md-3 d-flex flex-column">
          <Trans i18nKey="network_error" ns="Shared">
            <strong>Something wrong with your network connection. </strong>
            Please make sure you are connected to the internet and then refresh
            the page.
          </Trans>
        </div>
        <Button className="mt-2" onClick={() => window.location.reload()}>
          {t("buttons.refresh", { defaultValue: "Refresh" })}
        </Button>
      </Snake>
    </Box>
  );
}
